// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1Zks_","list":"PatternAutocomplete_list__2iakk"};